import {getUUID} from '../assets/utils'
export default {
  namespaced: true,
  state: {
    alternative: [], // 预选框中的菜单
    selected: [], // 选中的菜单
    tabs: [],
    keepAliveTabs: [],
    iframeViews: [],//iframe视图
    thirdMenus: [],//三级菜单
    headTabVm: {},
    staticIframes: [],//作为静态默认存在的iframe
    outScript: [],//需要加载外部的脚本
  },
  actions: {
  },
  mutations: {
    setAlternativeMenus(state, data) {
      if (Array.isArray(data)) {
        state.alternative = data
      } else {
        state.alternative.push(data)
      }
    },
    setSelectedMenus(state, data) {
      state.selected = data
    },
    filterMenusByRouter(state,routes){
      itera(state.selected,(menuItem) => {
        itera(routes,(routeItem) => {
          let menuName = menuItem.name.split('/').join('')
          if(routeItem.name == menuName&& routeItem.meta.cincc){
            menuItem.cincc = true
          }
        })
      })
      state.selected =  state.selected
    },
    addTab(state,{vm,route}){
      let {tabs,keepAliveTabs} = state
      let hasRoute = false
      for(let i in tabs){
        if(route.fullPath === tabs[i].fullPath){
          tabs[i].actived = true
          hasRoute = true
          //第二次进入此路由
          vm.$eventBus.emit('TAB_ROUTE_ACTIVED',tabs[i])
        }else{
          tabs[i].actived = false
        }
      }
      if(!hasRoute){
        //唯一id
        route._id_ = getUUID()
        state.tabs.push(route)
        if(!route.meta||!route.meta.noCache){
          keepAliveTabs.push(route.name)
        }
      }
    },
    deleTab(state,index){
      let {tabs,keepAliveTabs} = state
      if(tabs.length <= 1){
        return
      }
      tabs.splice(index,1)
      keepAliveTabs.splice(index,1)
    },
    setIframeComponents(state,params){
      let {iframeViews} = state
      let hasThisIframe = false
      for(let i in iframeViews){
        if(iframeViews[i].name === params.name){
          hasThisIframe = true
        }
      }
      if(!hasThisIframe){
        iframeViews.push({
          ...params
        })
      }
    },
    setThirdMenus(state,menu){
      state.thirdMenus = menu || []
    },
    //保存haadtab组件对对象
    setHeadTabVm(state,vm){
      state.headTabVm = vm
    },
    //设置默认存在的iframe
    setStaticIframes(state,params){
      state.staticIframes.push({
        name: params.name,
        linkUrl: params.linkUrl
      })
    },
    //设置默认存在的iframe
    setOutScripts(state,params){
      state.outScript.push({
        name: params.name,
        linkUrl: params.linkUrl
      })
    }
  },
}
function itera(obj,cb){
  for(let i in obj){
    cb&&cb(obj[i])
    if(obj[i].children&&obj[i].children.length){
      itera(obj[i].children,cb)
    }
  }
}
